import PropertyCleaners from './../mixins/property-cleaners';
import { computed } from '@ember/object';
import { notImplemented, subtractProperties } from '@intercom/pulse/lib/computed-properties';
import Constants from '@intercom/embercom-composer/lib/constants';
import { gt, equal, reads } from '@ember/object/computed';
import Em from 'ember';
export default Em.Object.extend(PropertyCleaners, {
  startIndex: 0,
  endIndex: 0,
  isMergeable: true,
  hasNonEditableContainer: false,
  options: notImplemented(),
  serializedTagName: reads('tagName'),
  isEntity: true,
  isAnchor: equal('type', 'anchor'),
  isAttribute: equal('type', 'attribute'),
  updateForDelete(block, deletedBlockRange) {
    let delta = deletedBlockRange.get('length');
    if (this.isExactRange(deletedBlockRange)) {
      return this.empty();
    }
    if (this.covers(deletedBlockRange)) {
      return this.contractFromRightBy(delta);
    }
    if (this.containedIn(deletedBlockRange)) {
      return this.empty();
    }
    if (this.intersectsLeft(deletedBlockRange)) {
      return this.contractFromRightBy(this.get('endIndex') - deletedBlockRange.get('startPoint.positionIndex'));
    }
    if (this.intersectsRight(deletedBlockRange)) {
      this.contractFromLeftBy(deletedBlockRange.get('endPoint.positionIndex') - this.get('startIndex'));
      return this.shiftLeftBy(delta);
    }
    if (this.isAdjacentLeftOfRange(deletedBlockRange) && delta === 0) {
      return this.contractFromRightBy(delta);
    }
    if (this.isAdjacentRightOfRange(deletedBlockRange)) {
      return this.shiftLeftBy(delta);
    }
  },
  empty() {
    this.setProperties({
      startIndex: 0,
      endIndex: 0
    });
  },
  openingHtmlForEditor: Em.computed('tagName', 'additionalAttributes', 'id', 'hasNonEditableContainer', function () {
    let html = '';
    html += `<${this.get('tagName')}`;
    if (this.get('additionalAttributes')) {
      html += ` ${this.get('additionalAttributes')}`;
    }
    html += ` data-id="${this.get('id')}">`;
    if (this.get('hasNonEditableContainer')) {
      html += `${Constants.ZERO_WIDTH_SPACE}<span>`;
    }
    return html;
  }),
  openingHtmlForSerialized: Em.computed('serializedTagName', 'serializedAttributes', function () {
    let html = `<${this.get('serializedTagName')}`;
    if (this.get('serializedAttributes')) {
      html += ` ${this.get('serializedAttributes')}`;
    }
    return html += '>';
  }),
  closingHtmlForEditor: Em.computed('tagName', 'hasNonEditableContainer', function () {
    let html = '';
    if (this.get('hasNonEditableContainer')) {
      html += `</span>${Constants.ZERO_WIDTH_SPACE}`;
    }
    html += `</${this.get('tagName')}>`;
    return html;
  }),
  closingHtmlForSerialized: Em.computed('serializedTagName', function () {
    return `</${this.get('serializedTagName')}>`;
  }),
  length: subtractProperties('endIndex', 'startIndex'),
  hasLength: gt('length', 0),
  type: notImplemented(),
  attributesToCopy: notImplemented(),
  info: computed('type', 'rangeInfo', function () {
    return `${this.type}: ${this.rangeInfo}`;
  }),
  rangeInfo: computed('startIndex', 'endIndex', function () {
    return `${this.startIndex} -> ${this.endIndex}`;
  }),
  setup: Em.on('init', function () {
    this._assertIsValid();
    if (!this.get('id')) {
      this.set('id', `entity-${Em.guidFor(this)}`);
    }
    if (this.cleanData) {
      this.cleanData();
    }
  }),
  cleanData() {},
  copy() {
    return this.constructor.create(this.getProperties(this.get('attributesToCopy')));
  },
  equals(entity) {
    //TODO: GJ: rename to isSameType
    return entity.get('type') === this.get('type');
  },
  expandTo(startIndex, endIndex) {
    this._assertPositiveStartIndex(startIndex);
    this._assertStartIndexLessThanOrEqualToEndIndex(startIndex, endIndex);
    if (this.get('startIndex') > startIndex) {
      this.expandToLeft(startIndex);
    }
    if (this.get('endIndex') < endIndex) {
      this.expandToRight(endIndex);
    }
    this._assertIsValid();
  },
  expandToLeft(startIndex) {
    this._assertPositiveStartIndex(startIndex);
    if (startIndex < this.get('startIndex')) {
      this.set('startIndex', startIndex);
    }
    this._assertIsValid();
  },
  expandToRight(endIndex) {
    let currentEndIndex = this.get('endIndex');
    if (endIndex > currentEndIndex) {
      this.set('endIndex', endIndex);
    }
    this._assertIsValid();
  },
  expandToRightBy(delta) {
    this.incrementProperty('endIndex', delta);
    this._assertIsValid();
  },
  shiftRightBy(delta) {
    //TODO pob This can shift the entity beyond range available in the block
    this.incrementProperty('startIndex', delta);
    this.incrementProperty('endIndex', delta);
    this._assertIsValid();
  },
  shiftLeftBy(delta) {
    //TODO tests; This can shift the entity beyond range available in the block
    this.decrementProperty('startIndex', delta);
    this.decrementProperty('endIndex', delta);
    this._assertIsValid();
  },
  contractFromLeft(startIndex) {
    this._assertPositiveStartIndex(startIndex);
    this._assertStartIndexLessThanEndOrEqualToEndIndex(startIndex);
    if (startIndex > this.get('startIndex')) {
      this.set('startIndex', startIndex);
    }
    this._assertIsValid();
  },
  contractFromLeftBy(delta) {
    //TODO tests, bounds validation
    this.incrementProperty('startIndex', delta);
    this._assertIsValid();
  },
  contractFromRight(endIndex) {
    this._assertEndIndexGreaterThanEndOrEqualToStartIndex(endIndex);
    if (endIndex < this.get('endIndex')) {
      this.set('endIndex', endIndex);
    }
    this._assertIsValid();
  },
  contractFromRightBy(delta) {
    //TODO tests, bounds validation
    this.decrementProperty('endIndex', delta);
    this._assertIsValid();
  },
  isExactRange(blockRange) {
    return this.get('startIndex') === blockRange.get('startPoint.positionIndex') && this.get('endIndex') === blockRange.get('endPoint.positionIndex');
  },
  isAfterRange(blockRange) {
    return this.get('startIndex') > blockRange.get('endPoint.positionIndex');
  },
  isBeforeRange(blockRange) {
    return this.get('endIndex') < blockRange.get('startPoint.positionIndex');
  },
  intersectsLeft(blockRange) {
    if (this.get('length') === 1) {
      return false;
    }
    let entityStartIndex = this.get('startIndex');
    let entityEndIndex = this.get('endIndex');
    let rangeStartIndex = blockRange.get('startPoint.positionIndex');
    let rangeEndIndex = blockRange.get('endPoint.positionIndex');
    return entityStartIndex < rangeStartIndex && entityEndIndex > rangeStartIndex && entityEndIndex <= rangeEndIndex;
  },
  intersectsRight(blockRange) {
    if (this.get('length') === 1) {
      return false;
    }
    let entityStartIndex = this.get('startIndex');
    let entityEndIndex = this.get('endIndex');
    let rangeStartIndex = blockRange.get('startPoint.positionIndex');
    let rangeEndIndex = blockRange.get('endPoint.positionIndex');
    return rangeStartIndex <= entityStartIndex && entityStartIndex < rangeEndIndex && entityEndIndex > rangeEndIndex;
  },
  covers(blockRange) {
    let entityStartIndex = this.get('startIndex');
    let entityEndIndex = this.get('endIndex');
    let rangeStartIndex = blockRange.get('startPoint.positionIndex');
    let rangeEndIndex = blockRange.get('endPoint.positionIndex');
    return entityStartIndex < rangeStartIndex && entityEndIndex > rangeEndIndex;
  },
  coversEdges(blockRange) {
    let entityStartIndex = this.get('startIndex');
    let entityEndIndex = this.get('endIndex');
    let rangeStartIndex = blockRange.get('startPoint.positionIndex');
    let rangeEndIndex = blockRange.get('endPoint.positionIndex');
    return entityStartIndex <= rangeStartIndex && entityEndIndex >= rangeEndIndex;
  },
  containedIn(blockRange) {
    if (blockRange.get('hasNoLength')) {
      return false;
    }
    let entityStartIndex = this.get('startIndex');
    let entityEndIndex = this.get('endIndex');
    let rangeStartIndex = blockRange.get('startPoint.positionIndex');
    let rangeEndIndex = blockRange.get('endPoint.positionIndex');
    return entityStartIndex >= rangeStartIndex && entityEndIndex <= rangeEndIndex && (entityStartIndex !== rangeStartIndex || entityEndIndex !== rangeEndIndex); // To avoid being the same as exact match
  },
  isWithinRange(blockRange) {
    let startIndex = blockRange.get('startPoint.positionIndex');
    let endIndex = blockRange.get('endPoint.positionIndex');
    let entityStartIndex = this.get('startIndex');
    let entityEndIndex = this.get('endIndex');
    return startIndex >= entityStartIndex && startIndex <= entityEndIndex || endIndex >= entityStartIndex && endIndex <= entityEndIndex || startIndex < entityStartIndex && endIndex > entityEndIndex;
  },
  isAdjacentRightOfRange(blockRange) {
    let entityStartIndex = this.get('startIndex');
    let rangeEndIndex = blockRange.get('endPoint.positionIndex');
    return entityStartIndex === rangeEndIndex;
  },
  isAdjacentLeftOfRange(blockRange) {
    let rangeStartIndex = blockRange.get('startPoint.positionIndex');
    let entityEndIndex = this.get('endIndex');
    return entityEndIndex === rangeStartIndex;
  },
  isType(type) {
    return this.get('type') === type;
  },
  isEqualTo(entity) {
    return this.get('type') === entity.get('type') && this.get('startIndex') === entity.get('startIndex') && this.get('endIndex') === entity.get('endIndex');
  },
  _assertIsValid() {
    this._assertStartIndexLessThanOrEqualToEndIndex(this.get('startIndex'), this.get('endIndex'));
  },
  _assertPositiveStartIndex(startIndex) {
    if (startIndex < 0) {
      throw new Error('startIndex must be zero or greater');
    }
  },
  _assertStartIndexLessThanOrEqualToEndIndex(startIndex, endIndex) {
    if (startIndex > endIndex) {
      throw new Error(`startIndex must be less than or equal to endIndex. startIndex was ${startIndex}, endIndex was ${endIndex}, type: ${this.get('type')}`);
    }
  },
  _assertStartIndexLessThanEndOrEqualToEndIndex(startIndex) {
    let endIndex = this.get('endIndex');
    if (startIndex > endIndex) {
      throw new Error(`startIndex must be less than or equal to endIndex. startIndex was ${startIndex}, endIndex was ${endIndex}, type: ${this.get('type')}`);
    }
  },
  _assertEndIndexGreaterThanEndOrEqualToStartIndex(endIndex) {
    let startIndex = this.get('startIndex');
    if (endIndex < startIndex) {
      throw new Error(`endIndex must be greater than or equal to startIndex. startIndex was ${startIndex}, endIndex was ${endIndex}, type: ${this.get('type')}`);
    }
  }
});